import { type MealsFilterSetup } from "../types/filters-setup.type";
import { DietTags } from "@/features/diets/components/diet-tags";
import { useTranslations } from "next-intl";
import React from "react";

export const FilterMealsItem = ({ data }: { data: MealsFilterSetup }) => {
  const t = useTranslations("common");

  return (
    <div className="text-left px-2 w-full">
      <div className="flex items-center gap-2 mb-1 ">
        {data.title}{" "}
        <DietTags
          className="bg-brand-grey4 border-0"
          tags={[
            {
              label: `${data.numberOfMeals}  ${t("meals", { meals: parseInt(data.numberOfMeals) }).replace(/^\d+\s*/, "")}`,
              name: "meals",
              type: "meals",
            },
          ]}
        />
      </div>
      <p className="font-normal text-sm whitespace-pre-line leading-[22px]">
        {data.description}
      </p>
    </div>
  );
};
